angular.module("TeamsApp").controller("TeamsSettingsLandingPageController", ["$scope", "$rootScope",
    function ($scope, $rootScope) {
        $scope.permissions = permissions;
        $rootScope.page_id = "settings";
        $rootScope.sub_app_page_id = "teams_settings";
    }]);